import { getNewDataset } from "redux/CreateDataset/selectors";
import { ReactNode, RefObject } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import XIcon from "assets/icons/XIcon";
import { DatasetStatus } from "types";

import styles from "./style.module.scss";

const InputBanner = ({
  body,
  bannerRef,
  isSaveBtnEnabled,
  handleSaveButtonClick = () => {}, //default action  till code is completed for all steps,
  closeBanner,
}: InputBannerProps) => {
  const newDataset = useSelector(getNewDataset);
  const isNewDatasetInitializing = newDataset
    ? newDataset.status === DatasetStatus.DRAFT
    : false;
  const viewOnly = !isNewDatasetInitializing;
  const saveBtnClassNames = classNames(styles.saveBtn, {
    [styles.disabledBtn]: !isSaveBtnEnabled,
  });

  return (
    <div className={styles.inputBannerContainer} ref={bannerRef}>
      {viewOnly && (
        <div className={styles.overlay}>
          <div className={styles.crossButton} onClick={closeBanner}>
            <XIcon />
          </div>
        </div>
      )}
      <div className={styles.inputBannerContent}>{body}</div>
      <div className={styles.actionButtons}>
        <div className={saveBtnClassNames} onClick={handleSaveButtonClick}>
          NEXT
        </div>
      </div>
    </div>
  );
};

export default InputBanner;

interface InputBannerProps {
  body: ReactNode;
  bannerRef: RefObject<HTMLDivElement>;
  handleSaveButtonClick?: () => void; //remove ? once all Parents have created the corresponding function
  isSaveBtnEnabled: boolean;
  closeBanner: () => void;
}
